<script setup lang="ts">
import { useLoadingOverlayHold } from "@/composables/useLoadingOverlay";

// Renders nothing itself: it holds the app-wide GlobalLoadingOverlay (see useLoadingOverlay).
defineOptions({ render: () => null });

useLoadingOverlayHold();
</script>
